import React, { Component } from 'react';
import styled from 'styled-components';
import colors from '@toolshed/styleguide/styles/colors';
import Spinner from '@toolshed/styleguide/components/Loader/Spinner/Spinner';
import Loader from './Loader';

const SPINNER_WIDTH = 75;
const SPINNER_STROKE = 6;
const SPINNER_RADIUS = SPINNER_WIDTH - SPINNER_STROKE * 2;
const SPINNER_TIMING = 300;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
`;

const SpinnerContainer = styled.div`
  transform: rotate(-90deg);
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  background-color: ${colors.lightest};
`;

export const Circle = props => (
  <circle
    stroke={colors.light}
    fill="transparent"
    strokeWidth={SPINNER_STROKE}
    strokeDasharray="10 15"
    strokeLinecap="round"
    cx={SPINNER_WIDTH}
    cy={SPINNER_WIDTH}
    r={SPINNER_RADIUS}
    {...props}
  />
);

class ProgressLoader extends Component {
  state = { progress: 0 };

  componentDidMount() {
    this.timer = setInterval(() => {
      const { progress } = this.state;
      const dotWidth = 100 / 16;

      this.setState({ progress: progress + dotWidth });
    }, SPINNER_TIMING);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const { progress } = this.state;

    return (
      <Container data-testid={this.props.testId}>
        <SpinnerContainer>
          <svg
            role="progressbar"
            height={SPINNER_WIDTH * 2}
            width={SPINNER_WIDTH * 2}
          >
            <defs>
              <mask id="border-mask">
                <Circle
                  stroke={colors.white}
                  style={{
                    transform: 'rotate(4deg)',
                    transformOrigin: '50% 50%',
                  }}
                />
              </mask>
            </defs>

            <Circle />

            <Spinner
              radius={SPINNER_WIDTH}
              stroke={SPINNER_STROKE}
              progress={progress}
              Circle={Circle}
              mask="url(#border-mask)"
            />
          </svg>
        </SpinnerContainer>

        <Loader size="extreme" />
      </Container>
    );
  }
}

export default ProgressLoader;
